// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__1tS0X","header":"styles_header__2wze9","title":"styles_title__YjWK3","tips":"styles_tips__3iKzX"};